import { render, staticRenderFns } from "./LogViewer.vue?vue&type=template&id=a2907df4&scoped=true&"
import script from "./LogViewer.vue?vue&type=script&lang=js&"
export * from "./LogViewer.vue?vue&type=script&lang=js&"
import style0 from "./LogViewer.vue?vue&type=style&index=0&id=a2907df4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2907df4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2907df4')) {
      api.createRecord('a2907df4', component.options)
    } else {
      api.reload('a2907df4', component.options)
    }
    module.hot.accept("./LogViewer.vue?vue&type=template&id=a2907df4&scoped=true&", function () {
      api.rerender('a2907df4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/logs/LogViewer.vue"
export default component.exports